var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrackVehicleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.484 3.516L18.786 5.214C20.526 6.948 21.6 9.348 21.6 12C21.6 17.304 17.304 21.6 12 21.6C6.696 21.6 2.4 17.304 2.4 12C2.4 7.104 6.066 3.072 10.8 2.484V4.908C7.398 5.478 4.8 8.436 4.8 12C4.8 15.978 8.022 19.2 12 19.2C15.978 19.2 19.2 15.978 19.2 12C19.2 10.014 18.396 8.214 17.094 6.906L15.396 8.604C16.26 9.474 16.8 10.674 16.8 12C16.8 14.652 14.652 16.8 12 16.8C9.348 16.8 7.2 14.652 7.2 12C7.2 9.768 8.736 7.902 10.8 7.368V9.93C10.086 10.344 9.6 11.112 9.6 12C9.6 13.326 10.674 14.4 12 14.4C13.326 14.4 14.4 13.326 14.4 12C14.4 11.112 13.914 10.35 13.2 9.93V0H12C5.37 0 0 5.37 0 12C0 18.624 5.37 24 12 24C18.624 24 24 18.624 24 12C24 8.688 22.656 5.688 20.484 3.516Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackVehicleIcon);
export default __webpack_public_path__ + "static/media/track-vehicle-icon.bc890eb0840d4dc31fec7cc3f7ecea16.svg";
export { ForwardRef as ReactComponent };